var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loveRecommend clear"},_vm._l((_vm.data),function(list,index){return _c('StandardCourseCard',{key:index,attrs:{"data":list}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }